import { render, staticRenderFns } from "./ads-postpaid-payment-card.vue?vue&type=template&id=7d663f25"
import script from "./ads-postpaid-payment-card.vue?vue&type=script&lang=js"
export * from "./ads-postpaid-payment-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports